import { OrderListItemModel } from './order.list.item.model';

export class PagedOrderDetails {
    currentPage: number;
    totalPages: number;
    pageSize: number;
    totalCount: number;
    items: OrderListItemModel[] = [];
}
